import ThemeBar from "./ThemeBar";
import { useContext } from "react";
import { AppContext } from "../AppContext";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer-container">
      <div className="footer-wrapper">
        <div>
          Copyright &copy; 2025 - &copy; {currentYear} All rights reserved || Powered By Advanced ERP
          USA
        </div>
        <div className="app-version">
          V<span>{process.env.REACT_APP_GUI_VERSION}</span>
        </div>
      </div>
      {/* <ThemeBar /> */}
    </div>
  );
}
